<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;margin-top:25%">
      <el-main style="padding: 100px 0px 0px 0px; width: 100%;height: 100%;">
        <div align='center'>
          <div style='padding:0px 0px 15px 0px;'>
            <el-button class="k0005-button1 css-btn" @click.native="btn1Click" type="primary" v-html="$t('MODULE.K0005_LBL_BTN1')"></el-button>
          </div>
          <div style='padding:0px 0px 15px 0px'>
            <el-button class="k0005-button1 css-btn" @click.native="btn2Click" type="primary" v-html="$t('MODULE.K0005_LBL_BTN2')"></el-button>
          </div>
          <div style='padding:0px 0px 15px 0px'>
            <!--upd by hexy 20210105 start -->
            <!--<el-button class="k0005-button css-btn"  type="primary" >
                            <a href = "mailto: 1757@ajis-group.com" style="text-decoration:none; ">
                                <span class="k0005-span" v-html="$t('MODULE.K0005_LBL_BTN3')"></span>
                            </a>
                        </el-button>-->
            <el-button class="k0005-button1 css-btn" @click.native="btn3Click" type="primary" v-html="$t('MODULE.K0005_LBL_BTN3')"></el-button>
            <!--upd by hexy 20210105 end -->
          </div>
          <div align="center">
            <el-button class="k0005-button css-btn" type="primary">
              <!--upd by hexy 20210105 start -->
              <!--<a href = "mailto: info-ajis-group@solare-sr.com" style="text-decoration:none; ">
                                <span class="k0005-span" v-html="$t('MODULE.K0005_LBL_BTN4')"></span>
                            </a>-->
              <a href="mailto: info1-ajis-group@solare-sr.com" style="text-decoration:none; ">
                <span class="k0005-span" v-html="$t('MODULE.K0005_LBL_BTN4')"></span>
              </a>
              <!--upd by hexy 20210105 start -->
            </el-button>
          </div>
        </div>
      </el-main>
    </el-container>
    <div>
      <el-row style="text-align:center;padding-top: 40px;">
        <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
let url = require('@/../config/sysConfig')
export default {
  data() {
    return {
      userInfo: [],
      imgIconComplete: require("@/statics/images/Complete.png"),
      imgIconPlan: require("@/statics/images/plan.png"),
      imgIconUnderway: require("@/statics/images/underway.png"),
    };
  },
  methods: {
    btn1Click() {
      window.open(url.routerUrl_K0005_btn1URL)
    },
    btn2Click() {
      var vm = this;
      localStorage.setItem(url.routerUrl_K0008, JSON.stringify(true))
      vm.$router.push({ path: url.routerUrl_K0008 })
    },
    //add by hexy 20210105 start
    btn3Click() {
      window.open(url.routerUrl_K0005_btn3URL)
    },
    //add by hexy 20210105 end
    // 戻る処理
    back_click() {
      var vm = this
      vm.$router.push({ path: url.routerUrl_Menu })
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
};
</script>
<style scope>
.k0005-span {
  font-size: 10pt;
  color: #ffffff;
}
.k0005-button {
  width: 65%;
  height: 60px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
  font-size: 14pt;
}
.k0005-button1 {
  width: 65%;
  height: 60px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
  font-size: 10pt;
}
/*导航*/
.home-content-menu_k0005 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}
/*面包屑*/
.el-crumb_k0005 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/k_0005.vue